import clsx from 'clsx';
import React from 'react';
import { Col } from 'components/layout';
import {} from './ContentBlockBody.types';
const ContentBlockBody = ({ children, className, colProps }) => (React.createElement(Col, { className: clsx('content-block--body', className), ...colProps }, children));
export default ContentBlockBody;
